/* tslint:disable */
/* eslint-disable */
/**
 * Payment API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 伝票情報
 * @export
 * @interface ListBillings200ResponseDataInner
 */
export interface ListBillings200ResponseDataInner {
    /**
     * 伝票ID
     * @type {string}
     * @memberof ListBillings200ResponseDataInner
     */
    id: string;
    /**
     * 伝票UUID
     * @type {string}
     * @memberof ListBillings200ResponseDataInner
     */
    uuid: string;
    /**
     * 伝票作成日時
     * @type {Date}
     * @memberof ListBillings200ResponseDataInner
     */
    createdAt: Date;
    /**
     * S.RIDEの注文番号
     * @type {string}
     * @memberof ListBillings200ResponseDataInner
     */
    orderNo: string;
    /**
     * ローミング先の注文番号（例：DiDiのOID、UberのTrip UUID）（デフォルト値：空欄）
     * @type {string}
     * @memberof ListBillings200ResponseDataInner
     */
    externalOrderNo: string;
    /**
     * 依頼元種別
     * @type {number}
     * @memberof ListBillings200ResponseDataInner
     */
    requestSourceType: ListBillings200ResponseDataInnerRequestSourceTypeEnum;
    /**
     * 車両状態
     * @type {number}
     * @memberof ListBillings200ResponseDataInner
     */
    carStatus: ListBillings200ResponseDataInnerCarStatusEnum;
    /**
     * 費目
     * @type {number}
     * @memberof ListBillings200ResponseDataInner
     */
    category: ListBillings200ResponseDataInnerCategoryEnum;
    /**
     * 実績支払方法
     * @type {string}
     * @memberof ListBillings200ResponseDataInner
     */
    paymentMethod: ListBillings200ResponseDataInnerPaymentMethodEnum;
    /**
     * 金額
     * @type {number}
     * @memberof ListBillings200ResponseDataInner
     */
    amount: number;
    /**
     * グループコード
     * @type {string}
     * @memberof ListBillings200ResponseDataInner
     */
    companyCode?: string;
    /**
     * グループ名
     * @type {string}
     * @memberof ListBillings200ResponseDataInner
     */
    groupName: string;
    /**
     * 会社ID
     * @type {string}
     * @memberof ListBillings200ResponseDataInner
     */
    companyId?: string;
    /**
     * 会社名
     * @type {string}
     * @memberof ListBillings200ResponseDataInner
     */
    companyName: string;
    /**
     * 営業所ID
     * @type {string}
     * @memberof ListBillings200ResponseDataInner
     */
    salesOfficeId?: string;
    /**
     * 営業所名
     * @type {string}
     * @memberof ListBillings200ResponseDataInner
     */
    salesOfficeName: string;
    /**
     * 無線番号
     * @type {string}
     * @memberof ListBillings200ResponseDataInner
     */
    radioNo: string;
    /**
     * 乗務員名
     * @type {string}
     * @memberof ListBillings200ResponseDataInner
     */
    driverName: string;
    /**
     * 乗務員コード
     * @type {string}
     * @memberof ListBillings200ResponseDataInner
     */
    driverCode: string;
    /**
     * 最新区分
     * @type {boolean}
     * @memberof ListBillings200ResponseDataInner
     */
    latest: boolean;
    /**
     * 伝票登録者（メールアドレス）
     * @type {string}
     * @memberof ListBillings200ResponseDataInner
     */
    registeredBy: string;
    /**
     * 実行状況（0:実行中, 1:完了）
     * @type {number}
     * @memberof ListBillings200ResponseDataInner
     */
    executionStatus: number;
    /**
     * 運賃種別
     * @type {number}
     * @memberof ListBillings200ResponseDataInner
     */
    fareType: ListBillings200ResponseDataInnerFareTypeEnum;
    /**
     * 注文種別
     * @type {number}
     * @memberof ListBillings200ResponseDataInner
     */
    orderType: ListBillings200ResponseDataInnerOrderTypeEnum;
    /**
     * 実運賃
     * @type {number}
     * @memberof ListBillings200ResponseDataInner
     */
    actualFare: number;
    /**
     * 有料道路料金
     * @type {number}
     * @memberof ListBillings200ResponseDataInner
     */
    tollroadFee: number;
    /**
     * 立替料金
     * @type {number}
     * @memberof ListBillings200ResponseDataInner
     */
    advancedFee: number;
    /**
     * チップ
     * @type {number}
     * @memberof ListBillings200ResponseDataInner
     */
    tip?: number;
    /**
     * キャンセル料
     * @type {number}
     * @memberof ListBillings200ResponseDataInner
     */
    cancellationFee?: number;
    /**
     * 実績支払方法
     * @type {string}
     * @memberof ListBillings200ResponseDataInner
     */
    tipPaymentMethod?: ListBillings200ResponseDataInnerTipPaymentMethodEnum | null;
    /**
     * 実績支払方法
     * @type {string}
     * @memberof ListBillings200ResponseDataInner
     */
    cancellationPaymentMethod?: ListBillings200ResponseDataInnerCancellationPaymentMethodEnum | null;
    /**
     * メモ
     * @type {string}
     * @memberof ListBillings200ResponseDataInner
     */
    note?: string;
}


/**
 * @export
 */
export const ListBillings200ResponseDataInnerRequestSourceTypeEnum = {
    SRIDE: 0,
    DIDI: 1,
    UBER: 2,
    RINGO_PASS: 3,
    SIMPLE_DISPATCH: 4
} as const;
export type ListBillings200ResponseDataInnerRequestSourceTypeEnum = typeof ListBillings200ResponseDataInnerRequestSourceTypeEnum[keyof typeof ListBillings200ResponseDataInnerRequestSourceTypeEnum];

/**
 * @export
 */
export const ListBillings200ResponseDataInnerCarStatusEnum = {
    REQUESTED: 1,
    SEARCH_FAILED: 2,
    DISPATCHED: 3,
    ARRIVED: 4,
    ON_BOARD: 5,
    SUBSTITUTE_REQUESTED: 6,
    PAYMENT_COMPLETED: 7,
    ONLINE_PAYMENT_FAILED: 8,
    ON_BOARD_QR: 9,
    UNUSED: 10,
    USER_CANCELED: 11,
    OPERATOR_CANCELED: 12,
    QR_CANCELED: 13
} as const;
export type ListBillings200ResponseDataInnerCarStatusEnum = typeof ListBillings200ResponseDataInnerCarStatusEnum[keyof typeof ListBillings200ResponseDataInnerCarStatusEnum];

/**
 * @export
 */
export const ListBillings200ResponseDataInnerCategoryEnum = {
    NORMAL: 0,
    CANCELLATION_FEE: 1,
    TIP: 2
} as const;
export type ListBillings200ResponseDataInnerCategoryEnum = typeof ListBillings200ResponseDataInnerCategoryEnum[keyof typeof ListBillings200ResponseDataInnerCategoryEnum];

/**
 * @export
 */
export const ListBillings200ResponseDataInnerPaymentMethodEnum = {
    IN_CAR_PAYMENT: '0',
    APP_PAYMENT_CREDIT_CARD: '1',
    EITHER: '2',
    APP_PAYMENT_APPLE_PAY: '3',
    RINGO_PASS_PAYMENT: '4',
    BACK_SEAT_PAYMENT: '5',
    APP_PAYMENT_CAB_CARD: '6',
    APP_PAYMENT_S_RIDE_BIZ: '7',
    APP_PAY_PAY: '10',
    APP_AU_PAY: '11',
    APP_D_PAY: '12',
    APP_R_PAY: '13',
    DIDI: '14',
    UBER: '15'
} as const;
export type ListBillings200ResponseDataInnerPaymentMethodEnum = typeof ListBillings200ResponseDataInnerPaymentMethodEnum[keyof typeof ListBillings200ResponseDataInnerPaymentMethodEnum];

/**
 * @export
 */
export const ListBillings200ResponseDataInnerFareTypeEnum = {
    METER: 0,
    PRE_FIXED: 1,
    FLAT: 2
} as const;
export type ListBillings200ResponseDataInnerFareTypeEnum = typeof ListBillings200ResponseDataInnerFareTypeEnum[keyof typeof ListBillings200ResponseDataInnerFareTypeEnum];

/**
 * @export
 */
export const ListBillings200ResponseDataInnerOrderTypeEnum = {
    NORMAL: 0,
    RESERVATION: 1
} as const;
export type ListBillings200ResponseDataInnerOrderTypeEnum = typeof ListBillings200ResponseDataInnerOrderTypeEnum[keyof typeof ListBillings200ResponseDataInnerOrderTypeEnum];

/**
 * @export
 */
export const ListBillings200ResponseDataInnerTipPaymentMethodEnum = {
    IN_CAR_PAYMENT: '0',
    APP_PAYMENT_CREDIT_CARD: '1',
    EITHER: '2',
    APP_PAYMENT_APPLE_PAY: '3',
    RINGO_PASS_PAYMENT: '4',
    BACK_SEAT_PAYMENT: '5',
    APP_PAYMENT_CAB_CARD: '6',
    APP_PAYMENT_S_RIDE_BIZ: '7',
    APP_PAY_PAY: '10',
    APP_AU_PAY: '11',
    APP_D_PAY: '12',
    APP_R_PAY: '13',
    DIDI: '14',
    UBER: '15'
} as const;
export type ListBillings200ResponseDataInnerTipPaymentMethodEnum = typeof ListBillings200ResponseDataInnerTipPaymentMethodEnum[keyof typeof ListBillings200ResponseDataInnerTipPaymentMethodEnum];

/**
 * @export
 */
export const ListBillings200ResponseDataInnerCancellationPaymentMethodEnum = {
    IN_CAR_PAYMENT: '0',
    APP_PAYMENT_CREDIT_CARD: '1',
    EITHER: '2',
    APP_PAYMENT_APPLE_PAY: '3',
    RINGO_PASS_PAYMENT: '4',
    BACK_SEAT_PAYMENT: '5',
    APP_PAYMENT_CAB_CARD: '6',
    APP_PAYMENT_S_RIDE_BIZ: '7',
    APP_PAY_PAY: '10',
    APP_AU_PAY: '11',
    APP_D_PAY: '12',
    APP_R_PAY: '13',
    DIDI: '14',
    UBER: '15'
} as const;
export type ListBillings200ResponseDataInnerCancellationPaymentMethodEnum = typeof ListBillings200ResponseDataInnerCancellationPaymentMethodEnum[keyof typeof ListBillings200ResponseDataInnerCancellationPaymentMethodEnum];


/**
 * Check if a given object implements the ListBillings200ResponseDataInner interface.
 */
export function instanceOfListBillings200ResponseDataInner(value: object): value is ListBillings200ResponseDataInner {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('uuid' in value) || value['uuid'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('orderNo' in value) || value['orderNo'] === undefined) return false;
    if (!('externalOrderNo' in value) || value['externalOrderNo'] === undefined) return false;
    if (!('requestSourceType' in value) || value['requestSourceType'] === undefined) return false;
    if (!('carStatus' in value) || value['carStatus'] === undefined) return false;
    if (!('category' in value) || value['category'] === undefined) return false;
    if (!('paymentMethod' in value) || value['paymentMethod'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    if (!('groupName' in value) || value['groupName'] === undefined) return false;
    if (!('companyName' in value) || value['companyName'] === undefined) return false;
    if (!('salesOfficeName' in value) || value['salesOfficeName'] === undefined) return false;
    if (!('radioNo' in value) || value['radioNo'] === undefined) return false;
    if (!('driverName' in value) || value['driverName'] === undefined) return false;
    if (!('driverCode' in value) || value['driverCode'] === undefined) return false;
    if (!('latest' in value) || value['latest'] === undefined) return false;
    if (!('registeredBy' in value) || value['registeredBy'] === undefined) return false;
    if (!('executionStatus' in value) || value['executionStatus'] === undefined) return false;
    if (!('fareType' in value) || value['fareType'] === undefined) return false;
    if (!('orderType' in value) || value['orderType'] === undefined) return false;
    if (!('actualFare' in value) || value['actualFare'] === undefined) return false;
    if (!('tollroadFee' in value) || value['tollroadFee'] === undefined) return false;
    if (!('advancedFee' in value) || value['advancedFee'] === undefined) return false;
    return true;
}

export function ListBillings200ResponseDataInnerFromJSON(json: any): ListBillings200ResponseDataInner {
    return ListBillings200ResponseDataInnerFromJSONTyped(json, false);
}

export function ListBillings200ResponseDataInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListBillings200ResponseDataInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'uuid': json['uuid'],
        'createdAt': (new Date(json['created_at'])),
        'orderNo': json['order_no'],
        'externalOrderNo': json['external_order_no'],
        'requestSourceType': json['request_source_type'],
        'carStatus': json['car_status'],
        'category': json['category'],
        'paymentMethod': json['payment_method'],
        'amount': json['amount'],
        'companyCode': json['company_code'] == null ? undefined : json['company_code'],
        'groupName': json['group_name'],
        'companyId': json['company_id'] == null ? undefined : json['company_id'],
        'companyName': json['company_name'],
        'salesOfficeId': json['sales_office_id'] == null ? undefined : json['sales_office_id'],
        'salesOfficeName': json['sales_office_name'],
        'radioNo': json['radio_no'],
        'driverName': json['driver_name'],
        'driverCode': json['driver_code'],
        'latest': json['latest'],
        'registeredBy': json['registered_by'],
        'executionStatus': json['execution_status'],
        'fareType': json['fare_type'],
        'orderType': json['order_type'],
        'actualFare': json['actual_fare'],
        'tollroadFee': json['tollroad_fee'],
        'advancedFee': json['advanced_fee'],
        'tip': json['tip'] == null ? undefined : json['tip'],
        'cancellationFee': json['cancellation_fee'] == null ? undefined : json['cancellation_fee'],
        'tipPaymentMethod': json['tip_payment_method'] == null ? undefined : json['tip_payment_method'],
        'cancellationPaymentMethod': json['cancellation_payment_method'] == null ? undefined : json['cancellation_payment_method'],
        'note': json['note'] == null ? undefined : json['note'],
    };
}

export function ListBillings200ResponseDataInnerToJSON(json: any): ListBillings200ResponseDataInner {
    return ListBillings200ResponseDataInnerToJSONTyped(json, false);
}

export function ListBillings200ResponseDataInnerToJSONTyped(value?: ListBillings200ResponseDataInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'uuid': value['uuid'],
        'created_at': ((value['createdAt']).toISOString()),
        'order_no': value['orderNo'],
        'external_order_no': value['externalOrderNo'],
        'request_source_type': value['requestSourceType'],
        'car_status': value['carStatus'],
        'category': value['category'],
        'payment_method': value['paymentMethod'],
        'amount': value['amount'],
        'company_code': value['companyCode'],
        'group_name': value['groupName'],
        'company_id': value['companyId'],
        'company_name': value['companyName'],
        'sales_office_id': value['salesOfficeId'],
        'sales_office_name': value['salesOfficeName'],
        'radio_no': value['radioNo'],
        'driver_name': value['driverName'],
        'driver_code': value['driverCode'],
        'latest': value['latest'],
        'registered_by': value['registeredBy'],
        'execution_status': value['executionStatus'],
        'fare_type': value['fareType'],
        'order_type': value['orderType'],
        'actual_fare': value['actualFare'],
        'tollroad_fee': value['tollroadFee'],
        'advanced_fee': value['advancedFee'],
        'tip': value['tip'],
        'cancellation_fee': value['cancellationFee'],
        'tip_payment_method': value['tipPaymentMethod'],
        'cancellation_payment_method': value['cancellationPaymentMethod'],
        'note': value['note'],
    };
}

